import { css } from '@emotion/react'
import colors from '~/styles/colors'

export const sidebar = css`
  border: 0.5rem solid ${colors.red};
`
